import CircularProgress from '@mui/material/CircularProgress';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';

export default function LoadingComponent(props) {
    return (
        <Box sx={{ mx: 'auto', textAlign: 'center', mt: 10 }}>
            <Typography variant="h1" sx={{ mb: 10 }}>
                Loading
            </Typography>
            <CircularProgress size={200} thickness={2} />
        </Box>
    );
}